import React from 'react'
import { config } from 'config'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import profilePic from './profile-pic.jpg'
import styles from './PortfolioIntroBanner.module.scss'
import IconHourglass from 'react-icons/lib/go/hourglass'
import IconGoLightBulb from 'react-icons/lib/go/light-bulb'

class PortfolioIntroBanner extends React.Component {

  static propTypes () {
    return {
      data: React.PropTypes.object,
    }
  }

  render () {
    const challenges = this.props.challenges || "";
    const responsibilities = this.props.responsibilities || "";

    return (
      <div className={styles.portfolioIntroBanner}>
        <Container
            style={{
              maxWidth: 1170,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
          <Grid columns={12}>
            <Breakpoint minWidth={700} widthMethod="componentWidth">
              <Span columns={6} className={styles.leftCol}>
                <IconHourglass className={styles.icon1}/>
                <h3>Challenges</h3>
                <div className={styles.content}>{challenges}</div>
              </Span>
              <Span columns={6} last className={styles.rightCol}>
                <IconGoLightBulb className={styles.icon2}/>
                <h3>Responsibilities</h3>
                <div className={styles.content}>{responsibilities}</div>
              </Span>         
            </Breakpoint>
            <Breakpoint maxWidth={700} widthMethod="componentWidth">
              <Span columns={12} className={styles.leftCol}>
                <IconHourglass className={styles.icon1}/>
                <h3>Challenges</h3>
                <div className={styles.content}>{challenges}</div>
              </Span>
              <Span columns={12} last className={styles.rightCol}>
                <IconGoLightBulb className={styles.icon2}/>
                <h3>Responsibilities</h3>
                <div className={styles.content}>{responsibilities}</div>
              </Span>      
            </Breakpoint>
          </Grid>

          

        </Container>
      </div>
    )
  }
}

export default PortfolioIntroBanner;



/** WEBPACK FOOTER **
 ** ../components/PortfolioIntroBanner.js
 **/